import { UseI18nHook } from "@core/i18n/i18n";
import { UseNavigationHook } from "@core/routing/use-navigate";
import { Notification, PatientNotificationData } from "@domain/notification/notification";
import { RoutesPath, TabPatientDetails } from "@ui/navigation/routes";
import { formatName } from "@utils/string-utils";

export class PatientRegisteredNotification extends Notification {
	private get data() {
		return this.notification.data as {
			patient: PatientNotificationData;
		};
	}

	format({ format }: UseI18nHook): string {
		return format("global.notifications.patient.registered", {
			patientName: formatName(this.data.patient),
		});
	}

	onClick(navigate: UseNavigationHook): void {
		navigate(RoutesPath.PatientDetails, {
			route: { patientId: this.data.patient.id },
			query: { active: TabPatientDetails.PROGRESS_TAB },
		});
	}
}
